import { ApiClient } from "./api-client";

export default class FileService {
    private static baseUrl: string = "/static";

    static getTemplateFileUrl(fileName: string, locale: string): Promise<string> {
        return ApiClient.get(`${this.baseUrl}/gettemplatefileurl?FileName=${fileName}&Locale=${locale}`).then(
            (data) => data.fileUrl);
    }
}